import { NgModule } from '@angular/core';
import { DraggableDirective } from './directives/draggable.directive';
import { DropDirective } from './directives/drop.directive';

@NgModule({
    declarations: [
        DraggableDirective,
        DropDirective,
    ],
    exports: [
        DraggableDirective,
        DropDirective,
    ],
})
export class DndModule {
}
